
import state from './moduleCommunityState'
import mutations from './moduleCommunityMutations'
import actions from './moduleCommunityActions'
import getters from './moduleCommunityGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}